/** Runtime config injected by the container via /config.js into window.__APP_CONFIG__. */
type AppConfig = {
  authority?: string;
  redirectUri?: string;
  apiBaseUrl?: string;
};

declare global {
  interface Window {
    __APP_CONFIG__?: AppConfig;
  }
}

const runtimeConfig: AppConfig = (typeof window !== 'undefined' && window.__APP_CONFIG__) || {};

export const AUTHORITY = runtimeConfig.authority || 'https://a-ci.ncats.io/_api/auth/clique';
export const REDIRECT_URI = runtimeConfig.redirectUri || 'https://localhost:4200';
export const API_BASE_URL = runtimeConfig.apiBaseUrl || 'https://a-ci.ncats.io/_api';
export const CLIENT_ID = 'clique';
export const DEFAULT_TENANT_ID = 'clique';

export const SESSION_IDLE_TIMEOUT_MS = 10 * 60 * 1_000;
export const TOKEN_NEAR_EXPIRY_WINDOW_MS = 2 * 60 * 1_000;

export const ENABLE_SESSION_DIAGNOSTICS =
  typeof import.meta !== 'undefined' &&
  (import.meta as unknown as { env?: { DEV?: boolean } }).env?.DEV === true;
